import React, { useState, useEffect, useCallback } from 'react';
import { Grid, CircularProgress, Box } from '@mui/material';
import UserInfoTable from './UserInfoTable';
import { useApiClient } from '../../context/ApiClientContext';
import Toast, { useToast } from '../../components/useToast';
import CustomAppBar from '../../content/Appbar/CustomAppBar';

function AllUsersManagement() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSiteCount, setTotalSiteCount] = useState(0);
  const [allSites, setAllSites] = useState([]);

  const apiClient = useApiClient();
  const {
    toastState,
    toastSetSuccessNotification,
    toastSetErrorNotification,
    toastOnClose,
  } = useToast();

  const setErrorMessage = (message) => {
    toastSetErrorNotification(message);
  };

  const fetchUsersAndSites = useCallback(async () => {
    setLoading(true);
    try {
      const [allUsers, allSitesResponse] = await Promise.all([
        apiClient.getAllUsers(),
        apiClient.getAllSite(),
      ]);
      setUsers(allUsers.data.map((user) => ({
        username: user.username,
        roles: user.roles,
        phoneNumber: user.phoneNumber,
        mfaMethod: user.mfaMethod,
        siteIds: user.siteIds,
      })));
      setTotalSiteCount(Array.isArray(allSitesResponse.data) ? allSitesResponse.data.length : 0);
      setAllSites(Array.isArray(allSitesResponse.data) ? allSitesResponse.data : []);
    } catch (error) {
      setUsers([]);
      setErrorMessage('Failed to fetch users.');
      setTotalSiteCount(0);
      setAllSites([]);
    } finally {
      setLoading(false);
    }
  }, [apiClient]);

  useEffect(() => {
    fetchUsersAndSites();
  }, [fetchUsersAndSites]);

  return (
    <Box sx={{ height: '100vh' }}>
      <Grid container>
        <Grid sx={{ width: 1 }}>
          <CustomAppBar
            name="Manage Users"
          />
        </Grid>
        <Grid sx={{ width: 1, padding: '0 30px' }}>
          {loading ? (
            <Box sx={{
              display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%',
            }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <UserInfoTable
              data={users}
              fetchUsers={fetchUsersAndSites}
              setSuccessMessage={toastSetSuccessNotification}
              setErrorMessage={toastSetErrorNotification}
              totalSiteCount={totalSiteCount}
              canDeleteUsers
              showSitesColumn
              allSites={allSites}
            />
          )}
          <Toast
            open={toastState.open}
            severity={toastState.severity}
            text={toastState.text}
            onClose={toastOnClose}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default AllUsersManagement;
